import createItemFetcher from "../helpers/item";
import { createUseItem } from "../helpers/fetchHooks";
var ApplicationType;
(function (ApplicationType) {
    ApplicationType["APP"] = "applications";
    ApplicationType["CONFIG"] = "configurations";
    ApplicationType["DASHBOARD_CONFIG"] = "dashboardConfigurations";
})(ApplicationType || (ApplicationType = {}));
const serverConfig = createItemFetcher(() => "/api/v1/config", "APPS_CONFIG", () => "config");
export const createServerConfig = () => {
    return serverConfig;
};
export const useServerConfig = createUseItem(serverConfig, (state) => state.serverConfig);
const isAnyAvailable = (config, applicationName, defaultValue = true, applicationType) => {
    const app = config &&
        config[applicationType] &&
        config[applicationType].find((app) => app.name === applicationName);
    return app ? app.available : defaultValue;
};
export const hasMultiEditAvailable = (config) => {
    return isConfigAvailable(config, "multiedit", false);
};
export const isApplicationAvailable = (config, applicationName, defaultValue = true) => isAnyAvailable(config, applicationName, defaultValue, ApplicationType.APP);
export const isConfigAvailable = (config, configurationName, defaultValue = false) => isAnyAvailable(config, configurationName, defaultValue, ApplicationType.CONFIG);
export const isDshWidgetAvailable = (config, configurationName, defaultValue = false) => isAnyAvailable(config, configurationName, defaultValue, ApplicationType.DASHBOARD_CONFIG);
//# sourceMappingURL=index.js.map